import { useAuthStore } from '~/stores/auth'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(async (nuxtApp) => {
  // Get the auth store
  const authStore = useAuthStore()
  
  // Initialize the auth store securely
  await authStore.initialize()
  
  // Add a navigation hook to verify the user is still authenticated on page changes
  nuxtApp.hook('page:start', async () => {
    if (authStore.isInitialized && authStore.isAuthenticated) {
      // Verify the user is still authenticated after navigating
      await authStore.checkSession(false)
    }
  })
  
  // Make auth available throughout the app
  nuxtApp.provide('auth', authStore)
}) 